export default "__VITE_ASSET__CtXMeVm0__"